export default __webpack_public_path__ + "static/media/location_preview_sunlit_swamp.18e057aa.svg";